import { render, staticRenderFns } from "./criteriaForm.vue?vue&type=template&id=34444051"
import script from "./criteriaForm.vue?vue&type=script&lang=js"
export * from "./criteriaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports